<div class="school-details-grid" [formGroup]="formGroup">
  <div class="school-details-header">
    <h5 class="school-details-title">School Details</h5>
  </div>
  <div class="school-details-field">
    <div class="user-record-field-wrapper">
      <label for="schoolId" class="field-label">School ID</label>
      <mat-form-field class="school-fields">
        <input
          id="schoolId"
          matInput
          type="text"
          placeholder="School ID"
          class="user-record-field-input"
          formControlName="schoolId" />
      </mat-form-field>
    </div>
  </div>
  <div class="school-details-field">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="schoolStatusId" class="field-label">Status</label>
      <mat-form-field class="school-fields">
        <mat-select id="schoolStatusId" formControlName="schoolStatusId" placeholder="Select Status">
          @for (status of schoolStatusOptions; track status.id) {
            <mat-option [value]="status.id">{{ status.name }}</mat-option>
          }
        </mat-select>
        @if (formGroup.get('schoolStatusId')?.invalid && formGroup.get('schoolStatusId')?.touched) {
          <mat-error>Status is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="school-details-field">
    <div
      class="user-record-field-wrapper"
      [matTooltip]="moreThanOneSchoolTooltip"
      [matTooltipDisabled]="!institutionHasMoreThanOneSchool">
      <label for="feinNumber" class="field-label">FEIN Number</label>
      <mat-form-field class="school-fields">
        <input
          id="feinNumber"
          matInput
          maxlength="9"
          placeholder="000000000"
          class="user-record-field-input"
          formControlName="feinNumber" />
        @if (formGroup.get('feinNumber')?.touched) {
          @if (formGroup.get('feinNumber')?.hasError('required')) {
            <mat-error>FEIN Number is required</mat-error>
          } @else if (formGroup.get('feinNumber')?.invalid) {
            <mat-error>FEIN Number is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="school-details-field">
    <div class="user-record-field-wrapper">
      <label for="dnpeNumber" class="field-label">DNPE Number</label>
      <mat-form-field class="school-fields">
        <input
          id="dnpeNumber"
          matInput
          type="text"
          placeholder="DNPE Number"
          class="user-record-field-input"
          formControlName="dnpeNumber" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('dnpeNumber')" />
    </div>
  </div>
  <div class="school-details-field">
    <div
      class="user-record-field-wrapper"
      [matTooltip]="moreThanOneSchoolTooltip"
      [matTooltipDisabled]="!institutionHasMoreThanOneSchool">
      <label for="fiscalYearEndDate" class="field-label"> Fiscal Year End Date </label>
      <mat-form-field class="school-fields">
        <div class="user-record-datepicker-wrapper">
          <input
            id="fiscalYearEndDate"
            matInput
            [matDatepicker]="fiscalYearPicker"
            placeholder="Select fiscal year end date"
            class="user-record-field-input"
            formControlName="fiscalYearEndDate"
            readonly
            (click)="fiscalYearPicker.open()" />

          <mat-datepicker-toggle matIconSuffix [for]="fiscalYearPicker" [disabled]="institutionHasMoreThanOneSchool">
          </mat-datepicker-toggle>
          <mat-datepicker #fiscalYearPicker></mat-datepicker>
        </div>

        @if (formGroup.get('fiscalYearEndDate')?.invalid && formGroup.get('fiscalYearEndDate')?.touched) {
          <mat-error>Fiscal Year End Date is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="school-details-field">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="aidProgramEligibility" class="field-label">Aid Program Eligibility</label>
      <mat-form-field class="school-fields">
        <mat-select
          #aidProgramSelect="matSelect"
          id="aidProgramEligibility"
          formControlName="aidProgramEligibility"
          placeholder="Select Aid Programs"
          multiple>
          @for (program of aidProgramOptions; track program) {
            <mat-option [value]="program">{{ program }}</mat-option>
          }
        </mat-select>
        @if (formGroup.get('aidProgramEligibility')?.invalid && formGroup.get('aidProgramEligibility')?.touched) {
          <mat-error>Aid Program Eligibility is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="school-details-field">
    <div class="user-record-field-wrapper">
      <label for="educationDeliveryMethod" class="field-label">Educational Delivery Method</label>
      <mat-form-field appearance="outline" class="full-width" class="school-fields">
        <mat-select
          #educationSelect="matSelect"
          id="educationDeliveryMethod"
          formControlName="educationDeliveryMethod"
          multiple
          (selectionChange)="educationSelect.close()">
          @for (option of educationDeliveryMethods; track option.id) {
            <mat-option [value]="option.id">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (formGroup.get('educationDeliveryMethod')?.invalid && formGroup.get('educationDeliveryMethod')?.touched) {
          <mat-error>Educational Delivery Method is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="school-details-field">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="schoolTypeId" class="field-label">School Type</label>
      <mat-form-field class="school-fields">
        <mat-select id="schoolTypeId" formControlName="schoolTypeId" placeholder="Select School Type">
          @for (type of schoolTypeOptions; track type.id) {
            <mat-option [value]="type.id">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
